<template>
    <div>
    <div class="site-black-bg min-vh-100 d-flex flex-column">
        <div class="d-flex align-items-center justify-content-center pt-3">
            <div class="d-flex align-items-center text-start text-white px-5">
                <h1 class="text-uppercase text-white display-1 home-text mx-2 text-center pb-5">Page Not Found</h1>
            </div>
        </div>

    </div>
    <Footer />
</div>

</template>

<script>
// import axios from "axios";
/* global grecaptcha */
import Footer from "@/components/Footer.vue";
export default {
        components: {
        Footer
    },
    data() {
        return {
            email: "",
            formSubmitted: false
        };
    },
    mounted() {
        const waitForRecaptcha = setInterval(() => {
            if (window.grecaptcha && window.grecaptcha.execute) {
                clearInterval(waitForRecaptcha);
                this.recaptchaReady = true;
            }
        }, 100);
    },
    methods: {
        async submitEmail() {
            if (!this.recaptchaReady) {
                console.error("reCAPTCHA not ready yet");
                return;
            }

            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(this.email)) {
                console.error("Invalid email format");
                alert("Please enter a valid email address.");
                return;
            }

            try {
                const token = await grecaptcha.execute('6LcaASsrAAAAADvXXVZOpweAdkZihozWT9yRjLef', { action: 'submit' });

                const response = await fetch("https://hooks.atlasimprov.com/verify-recaptcha", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    credentials: "include",
                    body: JSON.stringify({
                        email: this.email,
                        recaptchaToken: token,
                    }),
                });

                const result = await response.json();
                console.log("Success:", result);
            } catch (err) {
                console.error("reCAPTCHA or fetch error:", err);
            }
        }
    }

}
</script>
